<div
  class="if-input-wrapper"
  [class.if-input-sm]="size() === 'sm'"
  [class.if-input-xs]="size() === 'xs'"
  [class.if-input-invalid]="isInvalid()">
  @if (icon()) {
    <div class="if-input-icon" aria-hidden="true">
      @if (icon() === 'search') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          width="100%"
          height="100%"
          aria-hidden="true"
          focusable="false">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      }
    </div>
  }

  @if (type() === 'textarea') {
    <textarea
      #textareaElement
      class="if-input if-textarea"
      [class.if-textarea--auto]="autoResize().enabled"
      [rows]="rows()"
      [attr.maxlength]="maxlength()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [readonly]="readonly()"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-invalid]="isInvalid() || null"
      [value]="internalValue"
      (input)="onInput($event)"
      (blur)="onBlur()"></textarea>
  } @else if (type() === 'number') {
    <input
      #inputElement
      class="if-input"
      type="text"
      inputmode="decimal"
      inputNumber
      [attr.maxlength]="maxlength()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [readonly]="readonly()"
      [autocomplete]="autocomplete()"
      [attr.min]="minAttr"
      [attr.max]="maxAttr"
      [attr.step]="stepAttr === 'any' ? null : stepAttr"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-invalid]="isInvalid() || null"
      [value]="internalValue"
      (input)="onInput($event)"
      (blur)="onNumberBlur($event)" />
  } @else {
    <input
      #inputElement
      class="if-input"
      [type]="actualInputType"
      [attr.maxlength]="maxlength()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [readonly]="readonly()"
      [autocomplete]="autocomplete()"
      [attr.min]="minAttr"
      [attr.max]="maxAttr"
      [attr.step]="stepAttr"
      [attr.aria-label]="ariaLabel()"
      [attr.aria-invalid]="isInvalid() || null"
      [value]="internalValue"
      (input)="onInput($event)"
      (blur)="onBlur()" />
  }

  @if (type() === 'password') {
    <button
      type="button"
      class="if-password-toggle"
      (click)="togglePasswordVisibility()"
      [disabled]="isDisabled()"
      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
      @if (showPassword) {
        <!-- Eye with slash icon placeholder -->
        <svg class="if-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 11-4.243-4.243m4.242 4.242L9.88 9.88" />
        </svg>
      } @else {
        <!-- Eye icon placeholder -->
        <svg class="if-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      }
    </button>
  }
</div>
